import { Category, DemoState, Invoice, Trip, DEMO_DAY, metrics } from './model';

export const CATEGORIES: Category[] = [
  'Produto acabado',
  'Matéria prima',
  'Embalagem',
];
export const CARRIERS = ['Transportes JSL', 'Transpanorama', 'BBM Logística'];
export const UNITS = ['Franco da Rocha', 'Paulínia', 'Fazenda Rio Verde'];
const addMinutes = (date: string, minutes: number) =>
  new Date(Date.parse(date) + minutes * 60000).toISOString();
function tripRecord(month: number, index: number): Trip {
  const day = month === 10 ? 3 + (index % 12) : 2 + (index % 22);
  const hour = [6, 13, 18, 0][index % 4];
  const scheduled = `2026-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hour).padStart(2, '0')}:00:00-03:00`;
  const total = [
    735, 645, 810, 390, 480, 570, 720, 630, 180, 240, 300, 360, 420, 600, 900,
  ][index % 15];
  const late = index % 7 === 6;
  const start = addMinutes(scheduled, late ? 30 : 0);
  const unloaded = addMinutes(start, Math.min(total, 270));
  const docked = addMinutes(unloaded, 60);
  const loaded = addMinutes(docked, Math.max(0, total - 270));
  const farm = index % 5 === 2;
  return {
    id: `UNO-26${String(month).padStart(2, '0')}${String(index + 1).padStart(3, '0')}`,
    plate: ['FRT4J28', 'GHL9B12', 'DVS2A90', 'BCA7D43', 'EJK1F56', 'HXP3C71'][
      index % 6
    ],
    carrier: CARRIERS[index % 3],
    unit: farm ? UNITS[2] : UNITS[index % 2],
    circuit: !farm,
    site: farm ? 'Fazenda' : 'Fábrica',
    cnpj: farm ? '00.000.000/0002-00' : '00.000.000/0001-00',
    address: farm
      ? 'Estrada Rural, km 12 · Rio Verde/GO'
      : index % 2
        ? 'Distrito Industrial · Paulínia/SP'
        : 'Rodovia Pref. Luiz Salomão Chamma · Franco da Rocha/SP',
    category: CATEGORIES[index % 3],
    tons: 12 + (index % 18) + month / 10,
    operation: 'Descarga e carregamento',
    events: {
      scheduled,
      arrival: addMinutes(scheduled, late ? 30 : -15),
      unloaded,
      docked,
      loaded,
      exit: addMinutes(loaded, 20),
    },
    validation: index % 4 === 0 ? 'pending' : 'validated',
  };
}
function liveTrip(
  index: number,
  start: number,
  rec: number,
  exp: number,
  late = false
): Trip {
  const trip = tripRecord(10, index);
  const scheduled = `${DEMO_DAY}T${String(start).padStart(2, '0')}:00:00-03:00`;
  const unloaded = addMinutes(scheduled, rec);
  return {
    ...trip,
    id: `UNO-268${41 + index}`,
    unit: UNITS[index % 2],
    circuit: true,
    site: 'Fábrica',
    cnpj: '00.000.000/0001-00',
    address: `${UNITS[index % 2]} · São Paulo`,
    validation: 'pending',
    events: {
      scheduled,
      arrival: addMinutes(scheduled, late ? 15 : -15),
      unloaded: rec > 0 ? unloaded : undefined,
      docked:
        exp > 0 ? addMinutes('2026-10-19T18:00:00-03:00', -exp) : undefined,
    },
  };
}
export function seedState(): DemoState {
  const trips: Trip[] = [];
  for (let month = 1; month <= 10; month++)
    for (let index = 0; index < 15; index++)
      trips.push(tripRecord(month, index));
  trips.push(
    liveTrip(0, 6, 240, 480),
    liveTrip(1, 9, 240, 300),
    liveTrip(2, 10, 240, 240),
    liveTrip(3, 12, 180, 180),
    liveTrip(4, 14, 0, 0),
    liveTrip(5, 7, 240, 420, true)
  );
  const overnight = liveTrip(6, 6, 240, 420);
  overnight.events = {
    scheduled: '2026-10-18T20:00:00-03:00',
    arrival: '2026-10-18T19:45:00-03:00',
    unloaded: '2026-10-19T00:00:00-03:00',
    docked: '2026-10-19T11:00:00-03:00',
  };
  trips.push(overnight);
  trips.push(liveTrip(7, 11, 180, 0), liveTrip(8, 6, 300, 300));
  const discharge = tripRecord(10, 14);
  discharge.id = 'UNO-DESC-001';
  discharge.operation = 'Descarga';
  discharge.events = {
    scheduled: '2026-10-17T06:00:00-03:00',
    arrival: '2026-10-17T05:50:00-03:00',
    unloaded: '2026-10-17T17:30:00-03:00',
    released: '2026-10-17T17:45:00-03:00',
    exit: '2026-10-17T18:00:00-03:00',
  };
  discharge.validation = 'pending';
  trips.push(discharge);
  const invoices: Invoice[] = [];
  for (let month = 1; month <= 10; month++) {
    const candidates = trips.filter(
      (trip) =>
        trip.events.scheduled.slice(0, 7) ===
          `2026-${String(month).padStart(2, '0')}` &&
        metrics(trip).cents > 0 &&
        trip.validation === 'validated'
    );
    candidates.slice(0, 2).forEach((trip, index) => {
      const id = `FAT-2026-${String(invoices.length + 1).padStart(4, '0')}`;
      const approved = month < 10 || index === 0;
      invoices.push({
        id,
        carrier: trip.carrier,
        tripIds: [trip.id],
        status: approved ? 'approved' : 'pending',
        createdAt: trip.events.exit!,
        protocol: approved
          ? `WCK26${String(invoices.length + 1).padStart(6, '0')}A1`
          : undefined,
        history: [
          {
            at: trip.events.exit!,
            actor: 'Carga inicial',
            message: approved
              ? 'Fatura aprovada pela Corteva.'
              : 'Fatura aguardando análise da Corteva.',
          },
        ],
      });
    });
  }
  return { version: 2, trips, invoices, deliveries: [] };
}

export function loadState(): DemoState {
  try {
    const raw = localStorage.getItem('corteva-estadia-demo-v2');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (
        parsed.version === 2 &&
        Array.isArray(parsed.trips) &&
        parsed.trips.length &&
        parsed.trips.every(
          (trip: Trip) =>
            typeof trip.id === 'string' &&
            typeof trip.events?.scheduled === 'string' &&
            typeof trip.events?.arrival === 'string'
        ) &&
        Array.isArray(parsed.invoices) &&
        parsed.invoices.every(
          (invoice: Invoice) =>
            Array.isArray(invoice.tripIds) &&
            Array.isArray(invoice.history) &&
            ['pending', 'approved', 'rejected'].includes(invoice.status)
        ) &&
        Array.isArray(parsed.deliveries)
      ) {
        const clean = (value: string) =>
          value
            .replaceAll(' · demonstração', '')
            .replaceAll(' na demonstração', '')
            .replaceAll('Fatura de exemplo', 'Fatura')
            .replaceAll('FAT-DEMO-', 'FAT-2026-')
            .replaceAll(
              'Envio à Deloitte simulado. Nenhum e-mail foi enviado.',
              'Encaminhamento registrado localmente. Prévia de e-mail não enviada.'
            );
        const saved = parsed as DemoState;
        return {
          ...saved,
          trips: saved.trips.map((trip) => ({
            ...trip,
            validationReason: trip.validationReason
              ? clean(trip.validationReason)
              : undefined,
          })),
          invoices: saved.invoices.map((invoice) => ({
            ...invoice,
            id: clean(invoice.id),
            history: invoice.history.map((event) => ({
              ...event,
              actor: clean(event.actor),
              message: clean(event.message),
            })),
          })),
          deliveries: saved.deliveries.map((delivery) => ({
            ...delivery,
            invoiceId: clean(delivery.invoiceId),
            status: 'Registrado localmente',
          })),
        };
      }
    }
  } catch {}
  return seedState();
}
